import { render } from "./BackgroundStars.vue?vue&type=template&id=35391664&scoped=true"
import script from "./BackgroundStars.vue?vue&type=script&lang=js"
export * from "./BackgroundStars.vue?vue&type=script&lang=js"

import "./BackgroundStars.vue?vue&type=style&index=0&id=35391664&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-35391664"

export default script